// export const hostName = "http://185.182.111.157:8000";
export const hostName = "https://api.aqcham.uz";
export const baseUrl = `${hostName}/api/v1`;
export const web_socket_url = "wss://api.aqcham.uz/api/v1/ws";
export const apiTagTypes = ["Auth", "Team", "Organizations"];
